import { render } from "./AuctionHouse.vue?vue&type=template&id=85da4518&scoped=true"
import script from "./AuctionHouse.vue?vue&type=script&lang=js"
export * from "./AuctionHouse.vue?vue&type=script&lang=js"

import "./AuctionHouse.vue?vue&type=style&index=0&id=85da4518&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85da4518"]])

export default __exports__